import { defineRule } from 'vee-validate';
import {
  alpha,
  alpha_dash,
  alpha_spaces,
  between,
  integer,
  max_value,
  min_value
} from '@vee-validate/rules';

defineRule('integer', (value: any) => {
  const valError = integer(value);

  return valError || 'Should be an integer';
});

defineRule('maxValue', (value: any, params: any) => {
  const valError = max_value(value, params);

  return valError || `The value cannot be greater than ${params[0]}`;
});

defineRule('minValue', (value: any, params: any) => {
  const valError = min_value(value, params);

  return valError || `The value cannot be smaller than ${params[0]}`;
});

defineRule('validDomain', (value: any, params: any) => {
  const priority = params[0];

  const valError = !(!value.includes('@inditex.com') && Number(priority) === 3);

  return (
    valError ||
    `Requests of priority ${priority} must have responsible with inditex.com domain`
  );
});
